// Shared by the editor, queue and Gemini request validation.
export const MAX_GEMINI_TEXT_CHARACTERS = 1800;
export const MAX_CACHED_BLOCK_WORDS = 200;
export const MAX_CACHED_BLOCK_SOURCES = 32;
export const GEMINI_MAX_OUTPUT_TOKENS = 4096;
